const busTimelineData = [
  {
    mon_guan: '08:20',
    mon_kfs: '08:30',
    aft_guan: '13:35',
    aft_kfs: '13:30',
  },
  {
    mon_guan: '08:35',
    mon_kfs: '08:50',
    aft_guan: '13:50',
    aft_kfs: '13:45',
  },
  {
    mon_guan: '08:55',
    mon_kfs: '09:10',
    aft_guan: '14:05',
    aft_kfs: '14:00',
  },
  {
    mon_guan: '09:15',
    mon_kfs: '09:30',
    aft_guan: '14:20',
    aft_kfs: '14:15',
  },
  {
    mon_guan: '09:35',
    mon_kfs: '09:50',
    aft_guan: '14:35',
    aft_kfs: '14:30',
  },
  {
    mon_guan: '09:55',
    mon_kfs: '10:10',
    aft_guan: '14:50',
    aft_kfs: '14:45',
  },
  {
    mon_guan: '10:15',
    mon_kfs: '10:30',
    aft_guan: '15:05',
    aft_kfs: '15:00',
  },
  {
    mon_guan: '10:35',
    mon_kfs: '10:45',
    aft_guan: '15:20',
    aft_kfs: '15:15',
  },
  {
    mon_guan: '10:50',
    mon_kfs: '11:00',
    aft_guan: '15:35',
    aft_kfs: '15:30',
  },
  {
    mon_guan: '11:05',
    mon_kfs: '11:15',
    aft_guan: '15:50',
    aft_kfs: '15:45',
  },
  {
    mon_guan: '11:20',
    mon_kfs: '11:30',
    aft_guan: '16:05',
    aft_kfs: '16:00',
  },
  {
    mon_guan: '11:35',
    mon_kfs: '11:45',
    aft_guan: '16:20',
    aft_kfs: '16:15',
  },
  {
    mon_guan: '11:50',
    mon_kfs: '12:00',
    aft_guan: '16:35',
    aft_kfs: '16:30',
  },
  {
    mon_guan: '12:05',
    mon_kfs: '12:15',
    aft_guan: '16:50',
    aft_kfs: '16:45',
  },
  {
    mon_guan: '12:20',
    mon_kfs: '12:30',
    aft_guan: '17:05',
    aft_kfs: '17:00',
  },
  {
    mon_guan: '12:35',
    mon_kfs: '駐站休息',
    aft_guan: '17:20',
    aft_kfs: '17:15',
  },
  {
    mon_guan: '駐站休息',
    mon_kfs: '',
    aft_guan: '17:35',
    aft_kfs: '17:30',
  },
  {
    mon_guan: '',
    mon_kfs: '',
    aft_guan: '17:50',
    aft_kfs: '17:45',
  },
  {
    mon_guan: '',
    mon_kfs: '',
    aft_guan: '',
    aft_kfs: '18:00',
  },
];

export { busTimelineData };


// WEBPACK FOOTER //
// ./src/stores/busTimelineData.js